import React, { useEffect, useState } from 'react'
import { Row, Tabs } from 'antd';
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import UserList from './UserList';
import UserInfo from './UserInfo';

export default function UserManage() {

  const [current, setCurrent] = useState('userlist');
  const [detailTabs, setDetailTabs] = useState([]);
  const [listRefreshKey, setListRefreshKey] = useState(0);

  useEffect(() => {
    // 进入用户管理页默认只展示列表，避免历史 clickedUser 缓存误打开空详情页
    localStorage.removeItem('clickedUser');
  }, []);

  const openUserTab = (record) => {
    const userId = record.id;
    const key = `user-${userId}`;
    // 用户详情以邮箱作为 tab 标题，重复点击同一用户时只切换不重复新增
    setDetailTabs((prevTabs) => {
      if (prevTabs.some((tab) => tab.key === key)) {
        return prevTabs;
      }
      return [...prevTabs, { key, id: userId, email: record.email || 'User Detail' }];
    });
    localStorage.setItem('clickedUser', userId);
    setCurrent(key);
  };

  const closeUserTab = (targetKey) => {
    setDetailTabs((prevTabs) => {
      const nextTabs = prevTabs.filter((tab) => tab.key !== targetKey);
      if (current === targetKey) {
        const closedIndex = prevTabs.findIndex((tab) => tab.key === targetKey);
        const nextActive = nextTabs[closedIndex] || nextTabs[closedIndex - 1];
        setCurrent(nextActive ? nextActive.key : 'userlist');
        if (!nextActive) {
          localStorage.removeItem('clickedUser');
        }
      }
      return nextTabs;
    });
  };

  const updateTabTitle = (userId, userData) => {
    const key = `user-${userId}`;
    setDetailTabs((prevTabs) => prevTabs.map((tab) => (
      tab.key === key ? { ...tab, email: userData.email || tab.email } : tab
    )));
  };

  const refreshAfterAudit = () => {
    // 审核完成后同步刷新列表状态，当前详情由 UserInfo 自己重新拉取
    setListRefreshKey((value) => value + 1);
  };

  const items = [
    {
      label: (
        <span><MailOutlined /> User List</span>
      ),
      key: 'userlist',
      closable: false,
      children: <UserList refreshKey={listRefreshKey} onOpenUser={openUserTab} />,
    },
    ...detailTabs.map((tab) => ({
      label: (
        <span><UserOutlined /> {tab.email}</span>
      ),
      key: tab.key,
      closable: true,
      children: (
        <UserInfo
          userId={tab.id}
          onUserLoaded={(userData) => updateTabTitle(tab.id, userData)}
          onUpdated={refreshAfterAudit}
        />
      ),
    })),
  ];

    return (
        <div>
            <Row style={{ marginBottom: '24px' }}>
                <Tabs
                    activeKey={current}
                    onChange={setCurrent}
                    onEdit={(targetKey, action) => {
                      if (action === 'remove') {
                        closeUserTab(targetKey);
                      }
                    }}
                    type="editable-card"
                    hideAdd
                    items={items}
                    style={{ 
                        width: '100%',
                        fontSize: '15px',
                    }} 
                />
            </Row>
        </div>
    )
}
